// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1m5kD","productName":"Table_productName__3pKDL"};